import { CoreResource } from "../../core/index.js";
/**
 * {@link CoreResource} that support extensions object that adds properties
 * specific to given serialization technology.
 */
export class ExtendableCoreResource extends CoreResource {
    extensions;
}
//# sourceMappingURL=extendable-core-resource.js.map